import { render } from "./PinIcon.vue?vue&type=template&id=12f70a15&scoped=true"
const script = {}

import "./PinIcon.vue?vue&type=style&index=0&id=12f70a15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f70a15"]])

export default __exports__